<template>
    <div class="setup-mfa">
        <div v-if="!mfaType" class="alert alert-info">
            Please select Multi-Factor Authentication type you would like to configure for your account.
        </div>

        <div class="row">
            <div class="col-md-3">
                <div class="form-group required">
                    <label class="control-label">MFA type</label>
                    <select class="form-control" v-model="mfaType">
                        <option v-for="(type, id) in mfaTypes" :key="id" :value="id">{{ type }}</option>
                    </select>
                </div>
            </div>
        </div>

        <component
            v-if="mfaType"
            :is="mfaType"
            :is-loading="isLoading"
            :error-message="errorMessage"
            :type="mfaType"
            :phone-number="user.phone_number"
            @confirmed="handleConfirm"
        />
    </div>
</template>

<script>
import { ref, watch } from "vue";

import { mfaTypes, TYPE_MFA_SMS, TYPE_MFA_VOICE } from "@/pages/pending-actions/mfa-types";
import MfaAppSetupForm from "@/pages/common/MfaAppSetupForm.vue";
import MfaCodeSetupForm from "@/pages/common/MfaCodeSetupForm.vue";

export default {
    name: "MfaSetupForm",
    components: {
        'app': MfaAppSetupForm,
        'sms': MfaCodeSetupForm,
        'voice': MfaCodeSetupForm,
    },
    props: {
        user: Object,
        isLoading: Boolean,
        errorMessage: String,
        type: String,
    },
    setup(props, { emit }) {
        const errorMessage = ref('');
        const mfaType = ref('');

        const handleConfirm = async ({ code, type }) => {
            errorMessage.value = '';

            emit('confirmed', {
                code: code,
                type: type,
            });
        };

        watch(
            () => props.user.mfa_type,
            newValue => {
                mfaType.value = newValue;
                if (newValue === TYPE_MFA_SMS || newValue === TYPE_MFA_VOICE) {
                    errorMessage.value = '';
                }
            }
        );

        return {
            mfaType,
            mfaTypes,
            handleConfirm,
        };
    }
}
</script>
